// Third party
import { useTranslation } from 'react-i18next';
import { Player } from '@lottiefiles/react-lottie-player';
import Typography from '@mui/material/Typography';
import { NavLink } from 'react-router-dom';

// Components
import { WelcomeWrapper } from '@mgm/common/wrappers';
import { GenericHeader } from '@mgm/common/components/base';
import { BackToLogin } from '@mgm/common/components';
import { LanguageSelect } from '../../../components';

// Helpers
import { ANIMATIONS } from '../../../utils/enums';

const CheckEmail = () => {
  const { t } = useTranslation('welcome');

  const isEmbedded = window !== window.parent;

  const content = (
    <>
      <LanguageSelect />
      <GenericHeader
        titleProps={{
          children: t('checkYourMail'),
          textAlign: 'center',
        }}
        subtitleProps={{
          dangerouslySetInnerHTML: {
            __html: t('recoverText'),
          },
          textAlign: 'center',
        }}
      />
      <Player
        src={ANIMATIONS.CHECK_EMAIL}
        keepLastFrame
        autoplay
        style={{
          width: 180,
        }}
        className="check-email-anim"
      />
      <BackToLogin NavLinkComponent={NavLink as never} btnText={t('backToLogin')} />
      <Typography
        sx={{
          color: 'text.secondary',
        }}
        variant="body1"
        paddingTop={4}
        textAlign="center"
      >
        { t('didNotReceived') }
      </Typography>
    </>
  );

  return isEmbedded ? content : <WelcomeWrapper>{content}</WelcomeWrapper>;
};

export {
  CheckEmail,
};
